module.exports = __webpack_public_path__ + "img/close.49e44172.svg";